import API, { config } from '../API';

export const get = (token) => {
  const apiConf = config;
  apiConf.headers.Authorization = `Bearer ${token}`;
  return API.get('/category', apiConf);
};

export const post = (payload) => API.post('/category', payload);
